import React from 'react';
import { useMetaTags } from '../hooks/useMetaTags';
export function CookiePolicyPage() {
  useMetaTags({
    title: 'Cookie Policy | FindOnlineDegrees',
    description: 'Learn how FindOnlineDegrees uses cookies and similar technologies to support site functionality, analytics, and your preferences.'
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-1112" data-mp="1fd2j872ytyk4">
      {/* Hero Section */}
      <section className="w-full bg-[#1a2332] text-white py-16 px-4" data-id="element-1113" data-mp="1kbvml6ojg96k">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1114" data-mp="1kdqbew2xklfx">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-1115" data-mp="1p95hh1up5d1s">Cookie Notice</h1>
          <p className="text-gray-300 text-sm" data-id="element-1116" data-mp="1u9a2n56juvyc">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-1117" data-mp="1yac29n4dpa0u">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 space-y-8" data-id="element-1118" data-mp="3w1ohtwhplmb2">
          <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1119" data-mp="3wucdtgi412n">
            <p data-id="element-1120" data-mp="3z6se12p81d2">
              This Cookie Notice explains how FindOnlineDegrees.org uses cookies
              and similar technologies to recognize you when you visit our
              website. It explains what these technologies are, why we use them,
              and your rights to control our use of them.
            </p>
          </div>

          {/* What Are Cookies */}
          <div data-id="element-1121" data-mp="2wq2pahhe5ziw">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1122" data-mp="2wmeuzg44h934">
              1. WHAT ARE COOKIES?
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1123" data-mp="3pd705336182l">
              <p data-id="element-1124" data-mp="3pdyivdbnzbbg">
                Cookies are small data files placed on your device when you
                visit a website. Cookies are widely used to make websites work
                more efficiently and to provide reporting information.
              </p>
              <p data-id="element-1125" data-mp="28z707s4blifc">
                Cookies set by the website owner (in this case,
                FindOnlineDegrees.org) are called "first-party cookies." Cookies
                set by parties other than the website owner are called
                "third-party cookies." Third-party cookies enable features or
                functionality such as advertising, analytics, and interactive
                content.
              </p>
            </div>
          </div>

          {/* Why Do We Use Cookies */}
          <div data-id="element-1126" data-mp="r092zmgfvkou">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1127" data-mp="qzqwzy3z5s3q">
              2. WHY DO WE USE COOKIES?
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1128" data-mp="caba4t7ke6tb">
              <p data-id="element-1129" data-mp="h3xlmi1zs4nj">
                We use first-party and third-party cookies for several reasons:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1130" data-mp="3dkg0mckp21d">
                <li data-id="element-1131" data-mp="8a15pkzf7ogk">
                  <strong data-id="element-1132" data-mp="8bm09alqj7ef">Essential cookies:</strong> Required for technical
                  operation of our website (e.g., account login, security).
                </li>
                <li data-id="element-1133" data-mp="3uiagab4odnme">
                  <strong data-id="element-1134" data-mp="3ugpminq6q8pl">Performance and analytics cookies:</strong> Collect
                  information to help us understand website performance and
                  improve user experience.
                </li>
                <li data-id="element-1135" data-mp="36wgkzaq8xv7j">
                  <strong data-id="element-1136" data-mp="36x02wrfwcjlk">Advertising cookies:</strong> Deliver relevant ads and
                  measure effectiveness of our marketing campaigns.
                </li>
                <li data-id="element-1137" data-mp="3ftqx0yaw1odi">
                  <strong data-id="element-1138" data-mp="3fxeta57pwovx">Functionality cookies:</strong> Remember your
                  preferences and settings.
                </li>
              </ul>
            </div>
          </div>

          {/* Types of Cookies */}
          <div data-id="element-1139" data-mp="7fik0ykun66g">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1140" data-mp="7g1rflcvic68">
              3. TYPES OF COOKIES WE USE
            </h2>
            <div className="space-y-6 text-gray-700 leading-relaxed" data-id="element-1141" data-mp="2hqkbidyqfrp">
              <div data-id="element-1142" data-mp="hd6ju2xbb3vh">
                <h3 className="font-bold text-lg mb-2" data-id="element-1143" data-mp="hercfn02gcqp">
                  Strictly Necessary Cookies
                </h3>
                <p data-id="element-1144" data-mp="cg693epipcy1">
                  These are essential to provide services and cannot be switched
                  off. They are usually only set in response to actions you
                  take, such as setting privacy preferences or filling in forms.
                </p>
              </div>

              <div data-id="element-1145" data-mp="2fnndp236y8p8">
                <h3 className="font-bold text-lg mb-2" data-id="element-1146" data-mp="2fphqtu880wir">
                  Analytics and Performance Cookies
                </h3>
                <p data-id="element-1147" data-mp="1myzq2zuyz78i">
                  Help us count visits, traffic sources, and measure site
                  performance. Examples include Google Analytics cookies. These
                  cookies allow us to know which pages are most and least
                  popular and see how visitors move around the site.
                </p>
              </div>

              <div data-id="element-1148" data-mp="21x1sh6q9lmo6">
                <h3 className="font-bold text-lg mb-2" data-id="element-1149" data-mp="38bt2bzxd8huc">Advertising Cookies</h3>
                <p data-id="element-1150" data-mp="38dx3wb7sl4rg">
                  Used by us and third parties (such as Google Ads, Bing Ads, or
                  other ad networks) to build a profile of your interests and
                  show you relevant ads on other sites. They work by uniquely
                  identifying your browser and device.
                </p>
              </div>

              <div data-id="element-1151" data-mp="rwz5u86rch6d">
                <h3 className="font-bold text-lg mb-2" data-id="element-1152" data-mp="rwfwvgz3534h">
                  Functionality Cookies
                </h3>
                <p data-id="element-1153" data-mp="mye3o37y3nfa">
                  Enable enhanced functionality and personalization, such as
                  remembering your preferences. They may be set by us or by
                  third-party providers whose services we use on our pages.
                </p>
              </div>
            </div>
          </div>

          {/* How to Control Cookies */}
          <div data-id="element-1154" data-mp="40lee3q8vc0d">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1155" data-mp="413fperrkgf5">
              4. HOW CAN YOU CONTROL COOKIES?
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1156" data-mp="23atfo7ezesdn">
              <p data-id="element-1157" data-mp="1yf4btrvxipbj">
                You have the right to decide whether to accept or reject
                cookies. You can exercise your cookie preferences through your
                browser settings:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1158" data-mp="1hgkbx6wu1zy">
                <li data-id="element-1159" data-mp="3iwn3akqy71s8">
                  <strong data-id="element-1160" data-mp="3ixewjox2onfc">Browser Controls:</strong> Most web browsers allow you
                  to control cookies through their settings. However, if you
                  limit the ability of websites to set cookies, you may worsen
                  your overall user experience.
                </li>
                <li data-id="element-1161" data-mp="kdpwug25ykhu">
                  <strong data-id="element-1162" data-mp="kbvkvr8ve2pw">Opt-Out Links:</strong> You can opt out of
                  interest-based advertising through industry opt-out pages such
                  as the Digital Advertising Alliance (DAA) or Network
                  Advertising Initiative (NAI).
                </li>
                <li data-id="element-1163" data-mp="2q5vazyd06xa6">
                  <strong data-id="element-1164" data-mp="2v69hhbyyhz63">Do Not Track:</strong> Some browsers have a "Do Not
                  Track" feature that lets you tell websites you do not want to
                  have your online activities tracked.
                </li>
              </ul>
            </div>
          </div>

          {/* Third-Party Cookies */}
          <div data-id="element-1165" data-mp="1m9ui1c007nuz">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1166" data-mp="1m8b1rleclct7">
              5. THIRD-PARTY COOKIES
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1167" data-mp="1i88xr5l547ar">
              <p data-id="element-1168" data-mp="uhde4vqu8iel">
                In addition to our own cookies, we may use various third-party
                cookies to report usage statistics, deliver advertisements, and
                so on. Common third-party services include:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1169" data-mp="13cb8m79mw381">
                <li data-id="element-1170" data-mp="yiyj7ux4rse8">Google Analytics (analytics and performance)</li>
                <li data-id="element-1171" data-mp="atnqn0pxp4b6">Google Ads (advertising)</li>
                <li data-id="element-1172" data-mp="asco148862ln">Bing Ads (advertising)</li>
                <li data-id="element-1173" data-mp="6su5ug7sg5mi">Facebook Pixel (advertising and analytics)</li>
              </ul>
            </div>
          </div>

          {/* Updates to This Notice */}
          <div data-id="element-1174" data-mp="vp7mvmie8zas">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1175" data-mp="vpppr1zkabro">
              6. UPDATES TO THIS COOKIE NOTICE
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1176" data-mp="14nrxe0dsw2nx">
              <p data-id="element-1177" data-mp="19n4iafl42znv">
                We may update this Cookie Notice from time to time to reflect
                changes in the cookies we use or for other operational, legal,
                or regulatory reasons. Please revisit this Cookie Notice
                regularly to stay informed about our use of cookies.
              </p>
            </div>
          </div>

          {/* Contact Us */}
          <div data-id="element-1178" data-mp="1sdm92emdvl6l">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1179" data-mp="1sddsabn53vq4">
              7. CONTACT US
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1180" data-mp="1xdi25itjls7d">
              <p data-id="element-1181" data-mp="22btcrvrnw6qn">
                If you have questions about our use of cookies or this Cookie
                Notice, please contact us through the information provided on
                our website.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}